import React, { Component, useCallback, useEffect, useRef, useState } from "react";
import $ from "jquery";
import "./css/DeviceModal.css";
import { cmsAccount, jsonHeaders, msHeaders } from "./NavMenu";

export function DeviceModal({ shown, closeModal, playlistId }) {
    const [devices, setDevices] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState([]);
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                clearInterval(intervalId);
                fetchDevices();
            }
        }, 100);
    }, []);

    function fetchDevices() {
        var requestOptions = {
            method: "GET",
            headers: msHeaders,
            redirect: "follow",
        };
        fetch(`/api/devices/`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setDevices(result);
            });
    }

    function deviceClick(deviceId) {
        const element = document.getElementById(`device-${deviceId}`);
        let exist = false;
        selectedDevices.find(function (item, index) {
            if (item === deviceId) {
                var a = selectedDevices.splice(index, 1);
                setSelectedDevices(selectedDevices);
                element.style.border = null;
                element.style.borderRadius = null;
                exist = true;
            }
        });

        if (!exist) {
            selectedDevices.push(deviceId);
            element.style.border = "2px solid #094EFF";
            element.style.borderRadius = "8px";
        }
    }

    function addPlaylistToDevice() {
        if (!selectedDevices.length) {
            alert("Select a device to assign playlist.");
            return;
        }
        if (!playlistId) {
            alert("Select a playlist to assign");
            return;
        }
        const option = $("#interval-option").val();
        const value = Number($("#interval-value").val());
        if (!value) {
            alert("Please enter an interval value");
            return;
        }

        let newInterval = 0;
        switch (option) {
            case "weeks":
                newInterval = value * 7 * 24 * 60;
                break;
            case "days":
                newInterval = value * 24 * 60;
                break;
            case "hours":
                newInterval = value * 60;
                break;
            case "minutes":
                newInterval = value;
                break;
            default:
                newInterval = 60;
                break;
        }
        if (newInterval < 5) {
            alert("Interval time cannot less than 5 minutes.");
            return;
        }

        var requestOptions = {
            method: "PUT",
            headers: jsonHeaders,
            body: JSON.stringify({
                playlistId: playlistId,
                interval: newInterval ? newInterval : 60,
            }),
            redirect: "follow",
        };

        selectedDevices.forEach(function (uuid) {
            fetch(`/api/devices/${uuid}`, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (!result.id) {
                        alert(result);
                        return;
                    }
                    closeModal();
                })
                .catch((error) => console.log("error", error));
        });
    }
    return (
        <div
            className="devices-modal-container"
            id="devices-modal-container"
            style={{ display: shown ? "flex" : "none" }}
            onClick={() => {
                closeModal();
            }}
        >
            <div
                className="devices-modal"
                id="devices-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="devices-set">
                    {devices.map((device, i) => {
                        return (
                            <div
                                className="device-item"
                                key={device.uuid}
                                id={`device-${device.uuid}`}
                                onClick={() => {
                                    deviceClick(device.uuid);
                                }}
                            >
                                <div className="device-name-container">
                                    <div className="device-name-text">{device.name}</div>
                                </div>
                                {/* <div className="status-icon">
                                    <img src="icons/online.svg" />
                                </div>
                                <div className="status-icon" style={{ marginLeft: "125px" }} >
                                    <img src="icons/charging.svg" />
                                </div> */}
                            </div>
                        );
                    })}
                </div>
                <div className="bottom-bar">
                    Image-change Interval:
                    <input
                        id="interval-value"
                        type="number"
                        style={{ width: "80px" }}
                        defaultValue={1}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        }}
                    />
                    <select
                        id="interval-option"
                        className="form-select form-select-sm mx-3"
                        aria-label=".form-select-lg"
                        style={{ width: "100px" }}
                        defaultValue={"days"}
                    >
                        {["weeks", "days", "hours", "minutes"].map((option) => {
                            return <option key={option}>{option}</option>;
                        })}
                    </select>
                    <div
                        className="button-text-container"
                        onClick={() => {
                            addPlaylistToDevice();
                        }}
                    >
                        <div className="button-text text-nowrap">Assign</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
